import { actionTypes } from 'BASE/store/types'
import CONSTANT from 'BASE/common/chat/chat.constant'
import SETTING from 'BASE/common/chat/chat.setting'
import { goExternalChat } from '#BASE/common/chat/chat.chatExternal';

export default {
    props: {
        prop_room: Object,
    },
    data: function () {
        return {
            memberContainer: this.$store.state.chat.roomMemberContainers.find((item) => item.room.id === this.prop_room.id),
            isGroupRoom: this.prop_room.type === CONSTANT.roomType.DESCENDANT_GROUP,
            isGroupRoomAdmin: false
        };
    },
    methods: {
        openRoomWindow: async function () {
            if (this.hasChatExternalLink && this.prop_room.type === CONSTANT.roomType.CUSTOMER_SERVICE) {
                goExternalChat.call(this);
            } else {
                let loader;
                if (SETTING.ENABLE_CHECK_CONNECTION_BEFORE_ACTION) {
                    loader = this.$loading.show();
                }
                
                await this.$store.dispatch(actionTypes.CHAT_OPEN_ROOM_WINDOW, {
                    roomId: this.prop_room.id,
                    connectionParams: {
                        waitConnected: true,
                    },
                });

                if (SETTING.ENABLE_CHECK_CONNECTION_BEFORE_ACTION) {
                    loader.hide();
                }
            }
        },
    },
    computed: {
        isOnline: function () {
            return this.memberContainer.roomMembers[0].isOnline;
        },
        isChatDenied: function () {
            return this.memberContainer.roomMembers[0].isChatDenied;
        },
        unreadCount: function () {
            return this.prop_room.unreadCount;
        },
        name: function () {
            return this.prop_room.name;
        },

        // 多成員使用(例如群組聊天)
        memberCount: function () {
            return this.memberContainer.roomMembers.length;
        },
        onlineCount: function () {
            let count = 0;
            this.memberContainer.roomMembers.forEach(item => {
                if (item.isOnline) {
                    ++count;
                }
            });
            return count;
        },
        isGroupRoomManager: function() {
            //管理者權限會動態變更，所以需用computed偵測
            if (this.isGroupRoom) {
                let members = this.memberContainer.roomMembers;
                let member = members.find((item) => item.userId === this.$store.state.chat.userId);
                return member && member.role === CONSTANT.roomMemberRole.MANAGER;
            }
            return false
        },
        hasChatExternalLink() {
            return this.$store.state.userinfo.hasChatExternalLink;
        }
    },
    mounted: function () {
        // 初始化找出是否是群組聊天室管理者
        if (this.isGroupRoom) {
            let members = this.memberContainer.roomMembers;
            let member = members.find((item) => item.userId === this.$store.state.chat.userId);
            this.isGroupRoomAdmin = member.role === CONSTANT.roomMemberRole.ADMIN;
        }
    }
};
